/**
 * Hora en 24h (HH:mm[:ss]) o 12h ("9:00 AM", "2:30 PM") → "HH:mm:ss" para armar Date local.
 */
export function citaHoraToHms(hora) {
  if (hora == null || String(hora).trim() === '') return '00:00:00';
  const s = String(hora).trim();
  const twelve = s.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)\s*$/i);
  if (twelve) {
    let h = parseInt(twelve[1], 10);
    const mm = String(Math.min(59, parseInt(twelve[2], 10))).padStart(2, '0');
    const ss = twelve[3] != null ? String(Math.min(59, parseInt(twelve[3], 10))).padStart(2, '0') : '00';
    const mer = twelve[4].toUpperCase();
    if (mer === 'PM' && h !== 12) h += 12;
    if (mer === 'AM' && h === 12) h = 0;
    if (h > 23) h = 23;
    return `${String(h).padStart(2, '0')}:${mm}:${ss}`;
  }
  const m = s.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!m) return '00:00:00';
  const hh = String(Math.min(23, parseInt(m[1], 10))).padStart(2, '0');
  const mm = String(Math.min(59, parseInt(m[2], 10))).padStart(2, '0');
  const ss = m[3] != null ? String(Math.min(59, parseInt(m[3], 10))).padStart(2, '0') : '00';
  return `${hh}:${mm}:${ss}`;
}

/** Minutos desde medianoche; útil para ordenar citas con hora ya formateada en 12h. */
export function horaCitaAMinutosDesdeMedianoche(hora) {
  const hms = citaHoraToHms(hora);
  const [h, m] = hms.split(':').map((x) => parseInt(x, 10));
  if (Number.isNaN(h) || Number.isNaN(m)) return 0;
  return h * 60 + m;
}
